import {firePageOpened, firePageOpenedWithStatus} from "./api";
import {SUID_ELEMENT} from "./utils/suid";
import {getUrlParam} from "./utils/url";

firePageOpened(SUID_ELEMENT.value);

if (getUrlParam('status')) {
    firePageOpenedWithStatus(SUID_ELEMENT.value);
}